module.exports = __webpack_public_path__ + "img/m07.314631a6.png";